import { createApi } from '@reduxjs/toolkit/query/react';
import { axiosBaseQuery } from 'services/api';

// Tags for cache invalidation
export const MEMBER_INVITES_TAG = 'MemberInvites';

export const invitesApi = createApi({
  reducerPath: 'invitesApi',
  baseQuery: axiosBaseQuery({
    apiPath: '/api/management-panel/members/matching/',
  }),
  tagTypes: [MEMBER_INVITES_TAG],
  endpoints: builder => ({
    // Fetch member matching invites (returns the application)
    fetchMemberInvites: builder.query({
      query: ({ id, ...query }) => ({
        url: `${id}/`,
        params: query,
      }),
    }),
  }),
});

export const { useFetchMemberInvitesQuery } = invitesApi;
